import React, { useEffect, useMemo, useState } from 'react';
import { useBootcamps } from '../../../application/bootcamps/hooks/useBootcamps';
import { Row, Col } from '../../ui/grid';
import ToolbarComponent from '../../ui/section';
import Loader from '../../ui/loader';
import AttendanceTable from '../../ui/attendance';
import { DatePicker } from '../../ui/dateCalendar/datePicker';
import { PrimaryButton } from '../../ui/button';
import Input from '../../ui/input';

const BootcampAttendancePage = (props) => {
    const { getBootcampById, createAttendance, isLoading, safeId } = useBootcamps();
    const [bootcamp, setBootcamp] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [observations, setObservations] = useState('');
    const [attendanceList, setAttendanceList] = useState([]);

    const id = props.match?.params?.id;

    useEffect(() => {
        const load = async () => {
            const data = await getBootcampById(id);
            setBootcamp(data);
        };
        load();
    }, [getBootcampById, id]);

    const title = useMemo(() => bootcamp?.title || 'Asistencia', [bootcamp]);
    const goBack = () => props.history.goBack();

    const handleAttendanceChange = (updated) => setAttendanceList(updated || []);

    const handleCreate = async () => {
        const bootcampId = safeId(bootcamp) || id;
        const payload = {
            bootcampId,
            bootcampName: bootcamp?.title,
            date: selectedDate,
            observations,
            attendance: (attendanceList || []).map((e) => ({
                studentName: e.username,
                studentEmail: e.email,
                studentId: safeId(e),
                presence: !!e.attended,
                observation: e.observation,
            })),
        };
        await createAttendance(payload);
    };

    return (
        <ToolbarComponent label={title} showBackButton={true} onBackClick={goBack}>
            <Row>
                <Col md={12}>
                    <DatePicker
                        label="Fecha de asistencia"
                        onChange={setSelectedDate}
                        minDate={new Date()}
                        value={selectedDate}
                    />
                </Col>
                <Col md={12}>
                    <Input type="textarea" label="Observaciones" onChange={setObservations} value={observations} />
                </Col>
                <Col md={12}>
                    {isLoading && !bootcamp ? (
                        <Loader text="Cargando datos" />
                    ) : (
                        <AttendanceTable students={bootcamp?.students || []} onAttendanceChange={handleAttendanceChange} />
                    )}
                </Col>
                <Col md={12} className="text-right mt-5">
                    <PrimaryButton text="Crear asistencia" onClick={handleCreate} />
                </Col>
            </Row>
        </ToolbarComponent>
    );
};

export default BootcampAttendancePage;


